<template>
  <!-- Authors Table Card -->
  <div>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12">
            <h5 class="font-semibold m-0">用户管理</h5>
          </a-col>
          <a-col :span="24" :md="12" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 12px;
            ">
            <a-select 
              v-model="accountFilter" 
              placeholder="筛选账号类型" 
              style="width: 150px;"
              @change="onFilterChange"
            >
              <a-select-option value="all">全部账号</a-select-option>
              <a-select-option value="main">主账号</a-select-option>
              <a-select-option value="sub">子账号</a-select-option>
            </a-select>
            <a-button type="primary" class="add-shop" @click="() => (modal2Visible = true)">
              新增用户
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-table :columns="columns" :data-source="filteredData" :pagination="true">
        <template slot="username" slot-scope="username, record">
          <div class="username-info">
            <span class="username-text" :class="{ 'sub-account': record.is_sub }">
              {{ username }}
            </span>
          </div>
        </template>
        
        <template slot="accountType" slot-scope="text, record">
          <a-tag :color="record.is_sub ? 'orange' : 'blue'" class="account-type-tag">
            <a-icon :type="record.is_sub ? 'user' : 'crown'" />
            {{ record.is_sub ? '子账号' : '主账号' }}
          </a-tag>
        </template>
        
        <template slot="parent" slot-scope="parent, record">
          <div class="parent-info">
            <span v-if="record.is_sub && record.parent" class="parent-username">
              {{ record.parent }}
            </span>
            <span v-else class="no-parent">-</span>
          </div>
        </template>
        
        <template slot="website" slot-scope="website">
          <div class="author-info">
            <div class="website-tags">
              <div v-for="(domain, index) in website.split(',')" :key="domain">
                <a-tag 
                  class="website-tag"
                  @click="copyDomain(domain)"
                  color="blue"
                >
                  {{ domain }}
                </a-tag>
              </div>
            </div>
          </div>
        </template>
        <template slot="expiry_time" slot-scope="expiry_time">
          <div class="author-info">
            <h6 class="m-0" :class="{ 'text-red': isExpiringSoon(expiry_time) }">{{ expiry_time }}</h6>
          </div>
        </template>


        <template slot="status" slot-scope="status">
          <a-tag class="tag-status" :class="status ? 'ant-tag-primary' : 'ant-tag-muted'">
            {{ status ? "有效" : "失效" }}
          </a-tag>
        </template>

        <template slot="editBtn" slot-scope="row">
          <div style="white-space: pre">
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="truePass(row)">
              真实密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEdit(row)">
              编辑域名
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEditPass(row)">
              修改密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit" @click="openEditDays(row)">
              续期
            </a-button>
            <a-popconfirm title="确定要删除此用户吗?" ok-text="确定" cancel-text="取消" @confirm="deleteUser(row)">
              <a-button type="link" :data-id="row.key" style="color:red;">
                删除
              </a-button>
            </a-popconfirm>

          </div>
        </template>
      </a-table>
    </a-card>
    <!-- 新增用户 -->
    <a-modal v-model="modal2Visible" title="新增用户" centered cancelText="取消" okText="确认" @ok="addUser">
      <a-form-model :model="form">
        <a-form-model-item label="账号类型">
          <a-radio-group v-model="form.is_sub" @change="onAccountTypeChange">
            <a-radio :value="false">主账号</a-radio>
            <a-radio :value="true">子账号</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.is_sub" label="选择父账号">
          <a-select v-model="form.parent" placeholder="请选择父账号">
            <a-select-option v-for="user in mainAccounts" :key="user.username" :value="user.username">
              {{ user.username }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="用户昵称">
          <a-input v-model="form.username" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <a-input v-model="form.password" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="form.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <div class="quick-time-btns">
            <a-button size="small" @click="setQuickTime('add', 0.5)">半天</a-button>
            <a-button size="small" @click="setQuickTime('add', 1)">1天</a-button>
            <a-button size="small" @click="setQuickTime('add', 7)">1周</a-button>
            <a-button size="small" @click="setQuickTime('add', 30)">1个月</a-button>
            <a-button size="small" @click="setQuickTime('add', 90)">3个月</a-button>
          </div>
          <a-date-picker v-model="date1" show-time type="date" placeholder="选择到期时间" style="width: 100%; margin-top: 8px;" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 分配域名 -->
    <a-modal v-model="editUserVisible" title="编辑用户" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="editForm.website" :value="editForm.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 修改密码 -->
    <a-modal v-model="editPassVisible" title="修改密码" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <a-input v-model="editForm.password" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 续期 -->
    <a-modal v-model="editDaysVisible" title="续期" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <div class="quick-time-btns">
            <a-button size="small" @click="setQuickTimeEdit(0.5)">半天</a-button>
            <a-button size="small" @click="setQuickTimeEdit(1)">1天</a-button>
            <a-button size="small" @click="setQuickTimeEdit(7)">1周</a-button>
            <a-button size="small" @click="setQuickTimeEdit(30)">1个月</a-button>
            <a-button size="small" @click="setQuickTimeEdit(90)">3个月</a-button>
          </div>
          <a-date-picker v-model="editForm.days" show-time type="date" placeholder="选择到期时间" style="width: 100%; margin-top: 8px;" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>

  <!-- / Authors Table Card -->
</template>

<script>
import moment from "moment";
import { domainlist, register, updateuser, deleteuser, adminLogin } from "@/api/user";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.getAllDoamins();
  },
  data() {
    return {
      // Active button for the "Authors" table's card header radio button group.
      authorsHeaderBtns: "all",
      modal2Visible: false,
      editUserVisible: false,
      editPassVisible: false,
      editDaysVisible: false,
      domains: [],
      date1: "",
      accountFilter: "all",
      form: {
        username: "",
        days: "",
        password: "",
        website: [],
        is_sub: false,
        parent: null,
        expiry_time: "",
      },
      editForm: {
        username: "",
        website: [],
        password: "",
        days: "",
        expiry_time: "",
      },
    };
  },
  computed: {
    // Compute the data to display based on current page and page size
    displayData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.data.slice(startIndex, endIndex);
    },
    // 获取所有主账号列表
    mainAccounts() {
      return this.data.filter(user => !user.is_sub);
    },
    // 根据筛选条件过滤数据
    filteredData() {
      if (this.accountFilter === 'all') {
        return this.data;
      } else if (this.accountFilter === 'main') {
        return this.data.filter(user => !user.is_sub);
      } else if (this.accountFilter === 'sub') {
        return this.data.filter(user => user.is_sub);
      }
      return this.data;
    },
  },
  watch: {
    date1(newDate) {
      if (newDate) {
        this.calculateDaysDifference(newDate);
      }
    },
  },
  methods: {
    // Handle page change
    handlePageChange(page) {
      this.currentPage = page;
    },
    setModal1Visible(modal1Visible) {
      this.modal1Visible = modal1Visible;
    },
    calculateDaysDifference(date) {
      // 改为传递精确的到期时间字符串，而不是天数差
      const selectedDate = moment(date);
      this.form.expiry_time = selectedDate.format("YYYY-MM-DD HH:mm:ss");
    },
    setQuickTime(mode, days) {
      // 快捷设置到期时间
      // 将天数转换为小时，以支持半天等小数
      const hours = days * 24;
      const targetDate = moment().add(hours, 'hours');
      this.date1 = targetDate;
      this.form.expiry_time = targetDate.format("YYYY-MM-DD HH:mm:ss");
    },
    setQuickTimeEdit(days) {
      // 续期时的快捷时间设置
      // 将天数转换为小时，以支持半天等小数
      const hours = days * 24;
      const targetDate = moment().add(hours, 'hours');
      this.editForm.days = targetDate;
      this.editForm.expiry_time = targetDate.format("YYYY-MM-DD HH:mm:ss");
    },
    getAllDoamins() {
      domainlist().then((res) => {
        this.domains = res.data.available_domains;
      });
    },
    addUser() {
      // 构建请求数据，使用 expiry_time 代替 days
      const requestData = {
        username: this.form.username,
        password: this.form.password,
        website: this.form.website,
        is_sub: this.form.is_sub,
        parent: this.form.parent,
        expiry_time: this.form.expiry_time,
      };
      console.log(requestData);
      register(requestData).then((res) => {
        this.modal2Visible = false;
        this.$message.success("新增用户成功！");
        this.$emit("getUsers");
        // 重置表单
        this.form = {
          username: "",
          days: "",
          password: "",
          website: [],
          is_sub: false,
          parent: null,
          expiry_time: "",
        };
        this.date1 = "";
      });
    },
    editUser() {
      let updateForm = {}
      updateForm.username = this.editForm.username;
      
      // 如果有选择到期时间，使用 expiry_time
      if (this.editForm.days != "" && this.editForm.days != null) {
        const selectedDate = moment(this.editForm.days);
        updateForm.expiry_time = selectedDate.format("YYYY-MM-DD HH:mm:ss");
      }
      
      switch (this.modalTitle) {
        case "编辑用户":
          updateForm.website = this.editForm.website
          break;
        case "编辑密码":
          updateForm.password = this.editForm.password
          break;
      }

      updateuser(updateForm).then((res) => {
        this.editUserVisible = false;
        this.editPassVisible = false;
        this.editDaysVisible = false;
        this.$message.success("修改成功！");
        this.$emit("getUsers");
        // 重置编辑表单
        this.editForm.days = "";
        this.editForm.expiry_time = "";
      });
    },
    deleteUser(row) {
      console.log(row)
      deleteuser({ username: row.username }).then((res) => {
        if (res.status != 200) return this.$message.error("删除失败！");
        this.$message.success("删除成功！");
        this.$emit("getUsers");
      });

    },
    openEdit(row) {

      this.modalTitle = "编辑用户";
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editForm.username = row.username;
      this.editUserVisible = true;
    },
    openEditPass(row) {
      this.modalTitle = "编辑密码";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editPassVisible = true
    },
    openEditDays(row) {
      this.modalTitle = "续期";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editDaysVisible = true
    },
    isExpiringSoon(expiry_time_str) {
      // 将到期时间字符串转换为日期对象
      let expiryDate = new Date(expiry_time_str);

      // 获取当前时间
      let currentDate = new Date();

      // 计算到期时间与当前时间的时间差（毫秒数）
      let timeDifference = expiryDate.getTime() - currentDate.getTime();

      // 将时间差转换为天数
      let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      // 判断是否低于7天
      return daysDifference < 7;
    },
    truePass(row) {
      adminLogin({ username: row.username }).then(res => {
        if (res.status == 200) {
          const token = res.data.token
          window.open(process.env.VUE_APP_URL.replace("/api","/dashboard") + "?token=" + token)
        }

      })
    },
    copyDomain(domain) {
      navigator.clipboard.writeText(domain).then(() => {
        this.$message.success('域名已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    onAccountTypeChange(e) {
      // 当账号类型改变时，清空父账号选择
      if (!e.target.value) {
        this.form.parent = null;
      }
    },
    onFilterChange(value) {
      // 筛选条件变化时的处理
      this.accountFilter = value;
    },
  },
  mounted() {
    this.getAllDoamins();
  },
};
</script>
<style lang="css" scoped>
.btn-edit {
  color: blue;
}

.text-red {
  color: red;
}

.website-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.website-tag {
  cursor: pointer;
  margin: 0;
  padding: 2px 8px;
  border-radius: 4px;
  transition: all 0.3s;
}

.website-tag:hover {
  opacity: 0.8;
}

/* 新增样式 */
.username-info {
  display: flex;
  align-items: center;
}

.username-text {
  font-weight: 500;
  color: #333;
}

.username-text.sub-account {
  color: #fa8c16;
  font-style: italic;
}

.account-type-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
}

.account-type-tag .anticon {
  font-size: 12px;
}

.parent-info {
  display: flex;
  align-items: center;
}

.parent-username {
  color: #1890ff;
  font-weight: 500;
  background: #f0f8ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.no-parent {
  color: #999;
  font-style: italic;
}

.quick-time-btns {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.quick-time-btns .ant-btn {
  border-radius: 4px;
}
</style>
